<template>
  <div id="app" class="main" v-cloak v-show="isPageReady">

    <!-- 顶部通栏 -->
    <section class="top">
      <template v-if="isMobile">
        <h1 style="width: 0.5rem">
          <img :src="`${baseUrl}images/icon-192x192.png`" alt="" />
        </h1>
      </template>
      <template v-else>
        <h1>{{ t("title") }}</h1>
      </template>
      <article>
        <template v-if="isMobile">
          <a
            v-if="isShowInstallButton && !isApple"
            class="btn-small"
            style="margin-right: 0.1rem"
            href="javascript:"
            @click="onInstallApp"
            >{{t("addToDesktop")}}</a
          >
          <a
            v-if="!isShowInstallButton && isApple"
            class="btn-small"
            style="margin-right: 0.1rem"
            href="javascript:"
            @click="() => onShow('isShowGuideAddDesktop')"
            >{{t("addToDesktop")}}</a
          >
        </template>
        <i></i>
        <h2 @click.stop="popup.isShowLanguageMenu = !popup.isShowLanguageMenu" ref="languageToggleRef">
          {{ t("language") }}
        </h2>
        <aside
          class="animate__animated animate__fadeIn animate__faster"
          v-show="popup.isShowLanguageMenu"
          ref="languageMenuRef"
        >
          <ul>
            <li
              v-for="item in languageMenuList"
              :key="item.id"
              @click.stop="onChangeLanguage(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </aside>
      </article>
      <!-- AiHelp -->
      <a
        v-if="isMobile && isAihelpReady"
        class="button-aihelp-mobile"
        :class="{ 'has-unread': unreadCount > 0 }"
        href="javascript:"
        @click="onShowAiHelp"
        >AiHelp</a
      >
    </section>

    <!-- 主要内容 -->
    <main class="container">
      <!-- 已登录用户信息 -->
      <section class="user-box" v-if="isLogin && userInfo">
        <div class="user-avatar">
          <img :src="userInfo.headPic" alt="avatar" />
        </div>
        <div class="user-body">
          <div class="user-info">
            <h2>{{ userInfo.roleName }}</h2>
            <div class="user-vipLevel">
              <img
                :src="userInfo.vipLevelImg"
                alt="VIP Level"
              />
              <!-- <a :href="vipCenterURL">{{ t("vipBenefits") }}</a> -->
              <router-link :to="vipCenterURL">{{ t("vipBenefits") }}</router-link>
            </div>
            <h3>
              <span>{{ t("userLevel") }}:{{ userInfo.level }}</span>
              <span>{{ t("userServer") }}:{{ userInfo.serverName }}</span>
            </h3>
            <div class="user-coin">
              <i></i>
              <h3>{{ Math.trunc(userInfo.ccoin) }}</h3>
            </div>
          </div>
          <div class="user-switchAccount">
            <a href="javascript:" @click.prevent.stop="onLogout"
              >{{ t("switchAccount") }}</a
            >
          </div>
        </div>
      </section>
      <!-- 未登录用户 -->
      <section class="row" v-else>
        <header>
          <h2>{{ t("enterID") }}</h2>
          <aside>
            <!-- <a class="link-benefits" :href="vipCenterURL">{{ t("vipBenefits") }}</a> -->
            <router-link class="link-benefits" :to="vipCenterURL">{{ t("vipBenefits") }}</router-link>
          </aside>
        </header>
        <article>
          <div class="login-box">
            <div class="login-header" id="UserID">
              <input
                type="text"
                name="userID"
                id="InputUID"
                v-model="formData.userID"
                @blur="onNormalUserID"
              />
              <a
                href="javascript:"
                class="icon-help"
                v-if="isMobile"
                @click.prevent.stop="popup.isShowScreenshotID = true"
              ></a>
              <a
                href="javascript:"
                class="icon-help"
                v-else
                @mouseenter.prevent.stop="popup.isShowScreenshotID = true"
                @mouseleave.prevent.stop="popup.isShowScreenshotID = false"
              ></a>
            </div>
            <div class="login-footer">
              <a href="javascript:" @click.prevent.stop="onLogin">{{ t("login") }}</a>
            </div>
            <!-- 截图ID -->
            <div
              class="login-screenshot animate__animated animate__fadeIn animate__faster"
              v-show="popup.isShowScreenshotID"
            >
              <img :src="`${baseUrl}images/pay-center/screenshot-id.jpg`" alt="screenshot" />
            </div>
          </div>
          <div class="login-note">{{ t("uidTips") }}</div>
        </article>
      </section>

      <!-- 奖励中心 -->
      <section class="row">
        <a
          class="btn-rewardCenter"
          href="javascript:"
          @click.prevent.stop="() => onShow('isShowBenefitsCenter')"
          >{{ t("heading1") }}</a
        >
      </section>

      <!-- 优惠券 -->
      <section class="row">
        <header>
          <h2>{{ t("heading2") }}</h2>
        </header>
        <article>
          <!-- 已登录状态 -->
          <div v-if="isLogin">
            <div
              class="coupon-input-selected"
              v-if="!!currentCouponObject"
              @click.stop="() => onShow('isShowCoupon')"
            >
              <h3>{{ t("couponText2") }}</h3>
              <i class="icon-selected"></i>
              <footer>{{ currentCouponObject.name }}</footer>
            </div>
            <div
              class="coupon-input"
              v-else
              @click.stop="() => onShow('isShowCoupon')"
            >
              <h3>{{ t("couponText5") }}</h3>
            </div>
          </div>
          <!-- 未登录状态 -->
          <div
            class="coupon-input"
            v-else
            @click.stop="onFocusUserID"
          >
            <i class="icon-tips"></i>
            <h3>{{ t("couponText1") }}</h3>
          </div>
        </article>
      </section>

      <!-- 商品列表 -->
      <section class="row" style="margin-bottom: -0.2rem">
        <header>
          <h2>
            <a
              style="text-decoration: underline"
              href="javascript:"
              @click.prevent.stop="() => onShow('isShowOffers')"
              >{{ t("heading3") }}</a
            >
            <i class="icon-coin"></i>
          </h2>
        </header>
        <article class="list-box">
          <ul class="list-goods">
            <li
              v-for="item in goodsList"
              :key="item.id"
              :class="{ selected: formData.selectedGoods === item.id }"
              @click.stop="onSelectGoods(item)"
            >
              <header>
                <img :src="`${baseUrl}images/pay-center/${item.imgUrl}`" alt="" />
                <section>{{ item.coinNumber }}<i></i></section>
              </header>
              <footer>
                <template v-if="isProductInCouponRange(item, currentCouponObject)">
                  <div>{{ currentCurrency }} {{ formatPrice(item.originalPrice, null, currentCouponObject.coupon_off || 0) }}</div>
                  <div><del>{{ currentCurrency }} {{ formatPrice(item.originalPrice) }}</del></div>
                </template>
                <template v-else>
                  <div>{{ currentCurrency }} {{ formatPrice(item.originalPrice) }}</div>
                </template>
              </footer>
              <aside class="cashback" v-show="item.isShowRebate && !isProductInCouponRange(item, currentCouponObject)">+{{item.rebateNumber}}</aside>
            </li>
          </ul>
        </article>
      </section>

      <!-- 支付方式列表 -->
      <section class="row">
        <header>
          <h2>{{ t("heading4") }}</h2>
        </header>
        <article class="list-box">
          <ul class="list-payment">
            <li
              v-for="item in currentPaymentMethodList"
              :key="item.id"
              :class="{ selected: item.id === formData.selectedPaymentMethod }"
              @click.stop="() => onPaymentMethod(item.id)"
            >
              <img :src="`${baseUrl}images/pay-center/${item.icon}`" :alt="item.text" />
            </li>
          </ul>
        </article>
      </section>

      <!-- 合计总价 -->
      <section class="row">
        <div class="total-box">
          <header>
            <h3>{{ t("total") }}</h3>
          </header>
          <article v-if="currentGoodsObject">
            <template v-if="currentCouponObject">
              <h5>
                {{ formatPrice(currentGoodsObject.originalPrice, null, currentCouponObject.coupon_off || 0) }} {{ currentCurrency }}
              </h5>
              <del>
                {{ formatPrice(currentGoodsObject.originalPrice) }} {{ currentCurrency }}
              </del>
            </template>
            <h5 v-else>
              {{ formatPrice(currentGoodsObject.originalPrice) }} {{ currentCurrency }}
            </h5>
          </article>
        </div>
      </section>

      <!-- 支付按钮 -->
      <section class="row">
        <div class="flexbox-between">
          <div>
            <a
              v-if="!waitingPayment"
              class="btn-pay"
              href="javascript:"
              @click.prevent.stop="onPurchase"
              >{{ t("purchaseNow") }}</a
            >
            <a v-else class="btn-pay-disable" href="javascript:"
              >{{ t("purchaseNow") }}</a
            >
          </div>
          <div v-if="waitingPayment">
            <a
              class="btn-incomplete"
              href="javascript:"
              @click.prevent.stop="() => onShow('isShowIncompleteOrder')"
              >{{ t("orderTips") }}</a
            >
          </div>
        </div>
      </section>
    </main>

    <!-- PC端左侧边栏 -->
    <aside class="left" v-if="!isMobile">
      <article>
        <h2>APP ICON</h2>
        <p>{{ t("coinTips") }}</p>
        <div class="center mt" v-show="isShowInstallButton">
          <a
            class="btn-inlineblock"
            style="font-size: 16px; font-weight: normal"
            href="javascript:"
            @click="onInstallApp"
            >{{t("addToDesktop")}}</a
          >
        </div>
        <section class="left-faq">
          <p>
            <a href="javascript:" @click.prevent.stop="() => onShow('isShowFAQ')">
              <i></i>FAQ
            </a>
          </p>
          <p>
            <a href="https://coc-gw.fggame.net/tos.html" target="_blank" style="font-size: 16px; opacity: 0.8; text-decoration: underline;">
              {{ t("termsOfService") }}
            </a>
          </p>
          <p style="margin-top: 0px;">
            <a href="https://coc-gw.fggame.net/privacy.html" target="_blank" style="font-size: 16px; opacity: 0.8; text-decoration: underline;">
              {{ t("privacyPolicy") }}
            </a>
          </p>
        </section>
      </article>
    </aside>

    <!-- 移动端底部 -->
    <footer class="footer" v-if="isMobile">
      <article>
        <section class="logo">
          <img :src="`${baseUrl}images/icon-app.png`" alt="CITY OF CRIME" />
        </section>
        <section class="content">
          <h2>{{ t("title") }}</h2>
          <p>{{ t("coinTips") }}</p>
        </section>
        <section class="faq">
          <p>
            <a href="javascript:" @click.prevent.stop="() => onShow('isShowFAQ')"><i></i>FAQ</a>
          </p>
          <p>
            <a href="https://coc-gw.fggame.net/tos.html" target="_blank" style="font-size: 0.2rem; opacity: 0.8; text-decoration: underline; margin-top: -0.3rem;">
              {{ t("termsOfService") }}
            </a>
          </p>
          <p style="margin-top: 0px;">
            <a href="https://coc-gw.fggame.net/privacy.html" target="_blank" style="font-size: 0.2rem; opacity: 0.8; text-decoration: underline;">
              {{ t("privacyPolicy") }}
            </a>
          </p>
        </section>
      </article>
    </footer>



    <!-- 其他弹层（省略重复结构，保留核心逻辑） -->
    <div class="mask" v-show="popup.isShowMessage">
      <div class="mask-box">
        <header class="mask-header">
          <p>{{ tipMessage }}</p>
          <a
            class="btn-close"
            href="javascript:"
            @click.prevent.stop="() => onHide('isShowMessage')"
          ></a>
        </header>
      </div>
    </div>


    <!--弹层 福利中心 Benefits Center-->
    <div class="mask" v-show="popup.isShowBenefitsCenter">
        <div class="mask-box">
            <header class="mask-header">
                <h2>{{t("heading1")}}</h2>
            </header>
            <ul class="list-tab">
                <li :class="{'active': rewardTabActive==='login'}" @click="onTabActive('login')">{{t("benefitsTab1")}}</li>
                <!-- <li :class="{'active': rewardTabActive==='accumulated'}" @click="onTabActive('accumulated')">{{t("benefitsTab2")}}</li> -->
                <li :class="{'active': rewardTabActive==='first'}" @click="onTabActive('first')">{{t("benefitsTab3")}}</li>
            </ul>
            <div class="tab-box bg">
                <div class="task-box" v-show="rewardTabActive==='login'">
                    <h3>{{t("benefitsText2")}}</h3>
                    <p>{{t("benefitsText1")}}</p>
                    <ul class="list-grid">
                        <li>
                            <img :src="`${baseUrl}images/pay-center/reward-1.jpg`" alt="" />
                            <aside>5</aside>
                        </li>
                        <li>
                            <img :src="`${baseUrl}images/pay-center/reward-2.jpg`" alt="" />
                            <aside>5</aside>
                        </li>
                        <li>
                            <img :src="`${baseUrl}images/pay-center/reward-3.jpg`" alt="" />
                            <aside>5</aside>
                        </li>
                        <li>
                            <img :src="`${baseUrl}images/pay-center/reward-4.jpg`" alt="" />
                            <aside>1</aside>
                        </li>
                    </ul>
                    <div class="mt-m" v-if="!isLogin">
                        <a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowBenefitsCenter');onFocusUserID()">{{t("login")}}</a>
                    </div>
                    <footer v-else>
                        <div class="task-completed">
                            <img :src="`${baseUrl}images/pay-center/icon-completed.png`" alt="" />
                        </div>
                        <a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowBenefitsCenter')">{{t("ok")}}</a>
                    </footer>
                </div>
                <div class="task-box" v-show="rewardTabActive==='first'">
                    <h3>{{t("benefitsTab3")}}</h3>
                    <p>{{t("benefitsText1")}}</p>
                    <ul class="list-grid">
                        <li>
                            <img :src="`${baseUrl}images/pay-center/reward-5.jpg`" alt="" />
                            <aside>1</aside>
                        </li>
                    </ul>
                    <div class="mt-m" v-if="!isLogin">
                        <a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowBenefitsCenter');onFocusUserID()">{{t("login")}}</a>
                    </div>
                    <footer v-else>
                        <div class="task-completed" v-show="isRecharged">
                            <img :src="`${baseUrl}images/pay-center/icon-completed.png`" alt="" />
                        </div>
                        <a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowBenefitsCenter')">{{t("ok")}}</a>
                    </footer>
                </div>
            </div>
        </div>
    </div>

    <!--弹层 Coupon-->
    <div class="mask" v-show="popup.isShowCoupon">
        <div class="mask-box">
            <header class="mask-header">
                <h2>{{t("heading2")}}</h2>
                <p>{{t("couponText4")}}</p>
            </header>
            <ul class="list-tab">
                <li :class="{'active': couponTabActive==='myCoupon'}" @click="onTabActive('myCoupon')">{{t("couponTab1")}}</li>
                <li :class="{'active': couponTabActive==='available'}" @click="onTabActive('available')">{{t("couponTab2")}}</li>
            </ul>
            <div class="tab-box">
                <div v-show="couponTabActive==='myCoupon'">
                    <template v-if="myCouponList.length > 0">
                        <template v-if="isCouponsAvailable">
                            <section v-for="item in myCouponList" :key="item.id" :class="{'coupon-item':true, 'selected':formData.selectedCoupon===item.id}" @click.stop="onSelectCoupon(item)">
                                <header>
                                    <h3>{{item.name}}</h3>
                                </header>
                                <div class="coupon-info">
                                    <article>{{ formatCouponConditions(item) }}</article>
                                    <footer>{{ formatTimeRemaining(item.expireAt) }}</footer>
                                </div>
                            </section>
                        </template>
                        <template v-else>
                            <section class="coupon-item disabled" v-for="item in myCouponList" :key="item.id">
                                <header>
                                    <h3>{{item.name}}</h3>
                                </header>
                                <div class="coupon-info">
                                    <article>{{ formatCouponConditions(item) }}</article>
                                    <footer>{{ formatTimeRemaining(item.expireAt) }}</footer>
                                </div>
                            </section>
                        </template>
                    </template>
                    <div v-else class="center" style="padding: 1rem 0; color: #999; font-size: 0.28rem;">
                        {{ t("couponText3") }}
                    </div>
                </div>
                <div v-show="couponTabActive==='available'">
                    <section class="coupon-item" v-for="item in availableCouponList" :key="item.id">
                        <header>
                            <h3>{{item.name}}</h3>
                        </header>
                        <div class="coupon-info" v-if="item.display">
                            <article>{{ t(item.display.line1, item.display.params || {}) }}</article>
                            <footer v-if="item.display.line2" style="font-size: 0.18rem; color: #999; margin-top: 0.01rem;">
                                {{ t(item.display.line2, item.display.params || {}) }}
                            </footer>
                        </div>
                        <div class="coupon-info" v-else>
                            <article>{{item.description}}</article>
                        </div>
                    </section>
                </div>
                <div class="mt-m">
                    <a class="btn-ok" href="javascript:" @click.prevent.stop="onConfirmCoupon">OK</a>
                </div>
            </div>
        </div>
    </div>

    <!--弹层 Offers-->
    <div class="mask" v-show="popup.isShowOffers">
        <div class="mask-box" :class="{'mt-sm': !isMobile}">
            <header class="mask-header">
                <h2>{{t("usingText1")}}</h2>
                <p>{{t("usingText2")}}</p>
            </header>
            <article class="mask-body">
                <div class="swiper mask-swiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide"><img :src="`${baseUrl}images/pay-center/screenshot-howtouse1.jpg`" alt="" /></div>
                        <div class="swiper-slide"><img :src="`${baseUrl}images/pay-center/screenshot-howtouse2.jpg`" alt="" /></div>
                        <div class="swiper-slide"><img :src="`${baseUrl}images/pay-center/screenshot-howtouse3.jpg`" alt="" /></div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
                <div class="mt-m">
                    <a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowOffers')">OK</a>
                </div>
            </article>
        </div>
    </div>

    <!--弹层 FAQ-->
    <div class="mask" v-show="popup.isShowFAQ">
        <div class="mask-box">
            <header class="mask-header">
                <h2>{{t("heading5")}}</h2>
            </header>
            <article class="mask-body">
                <div class="scroll-box" v-html="translateText.htmlText1"></div>
                <div class="mt"><a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowFAQ')">OK</a></div>
            </article>
        </div>
    </div>

    <!--弹层 未完成订单-->
    <div class="mask" v-show="popup.isShowIncompleteOrder">
        <div class="mask-box">
            <header class="mask-header">
                <h2>{{t("orderHeader")}}</h2>
                <a class="btn-close" href="javascript:" @click.prevent.stop="onHide('isShowIncompleteOrder')"></a>
            </header>
            <article class="mask-body">
                <div class="scroll-box">
                    <ul class="list-order-incomplete" v-if="!!waitingPayment">
                        <li>
                            <dl>
                                <dt>{{t("orderText9")}}</dt>
                                <dd>{{waitingPayment.transactionId}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText1")}}</dt>
                                <dd>{{formatDate(waitingPayment.orderDateStr)}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText2")}}</dt>
                                <dd>{{waitingPayment.roleName}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText3")}}</dt>
                                <dd>{{waitingPayment.serverId}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText4")}}</dt>
                                <dd>{{waitingPayment.orderDetail}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText5")}}</dt>
                                <dd>{{waitingPayment.couponDiscount}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText6")}}</dt>
                                <dd>{{waitingPayment.rebateNumber}}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText7")}}</dt>
                                <dd>{{waitingPayment.currencySymbol}} {{ formatPrice(waitingPayment.payPriceLocal) }}</dd>
                            </dl>
                            <dl>
                                <dt>{{t("orderText8")}}</dt>
                                <dd>{{formatDate(waitingPayment.expireDateStr)}}</dd>
                            </dl>
                            <div class="mt center"><a class="btn-inlineblock" href="javascript:" @click.prevent="onContinuePayment">{{t("orderbutton")}}</a></div>
                        </li>
                    </ul>
                </div>
            </article>
        </div>
    </div>

    <!--弹层 支付结果显示-->
    <div class="mask" v-show="popup.isShowPaymentResults">
        <div class="mask-box">
            <header class="mask-header" style="padding: 0.5rem 0.3rem">
                <h2 v-if="popup.isPaymentSuccessful">{{t("paymentResult1")}}</h2>
                <h2 v-else>{{t("paymentResult2")}}</h2>
            </header>
            <article class="mask-body">
                <a class="btn-ok" href="javascript:" @click.prevent.stop="onKnownPaymentResult">{{t("paymentButton")}}</a>
            </article>
        </div>
    </div>

    <!--弹层 引导添加到桌面-->
    <div class="mask" v-show="popup.isShowGuideAddDesktop">
        <div class="mask-box">
            <article class="mask-body">
                <img class="blockimg" :src="`${baseUrl}images/pay-center/add-desktop-guide.jpg`" alt="" />
                <div class="mt"><a class="btn-ok" href="javascript:" @click.prevent.stop="onHide('isShowGuideAddDesktop')">OK</a></div>
            </article>
        </div>
    </div>
    <!-- 弹层：Loading -->
    <div class="mask" v-show="popup.isLoading" style="z-index: 9999;">
      <div class="mask-box">
        <header class="mask-loading">
          <img :src="`${baseUrl}images/loading.gif`" alt="loading" />
          <p>{{ t("loading") }}</p>
        </header>
      </div>
    </div>
    <!-- AiHelp -->
    <a class="button-aihelp" :class="{ 'has-unread': unreadCount > 0 }" title="Customer service" v-if="!isMobile&&isAihelpReady" @click="onShowAiHelp()"></a>
  </div>
</template>

<script>
// 注意：此块中的代码仅执行一次，用于定义跨路由共享的全局单例
import { ref } from 'vue';
const isAihelpReady = ref(false);
const unreadCount = ref(0);
const lastAppId = ref("");

// 注册全局唯一监听器（捕获外部全局 refs）
const registerGlobalAiHelpListeners = () => {
  if (typeof AIHelpSupport === 'undefined' || window._aiHelpRegistered) return;

  // 1. 监听初始化结果
  AIHelpSupport.registerAsyncEventListener("initialization", (jsonData) => {
    console.log(`AIHelp initialization callback: ${jsonData.isSuccess}`);
    if (jsonData.isSuccess) {
      isAihelpReady.value = true;
    }
  });

  // 2. 监听消息抵达 (自动更新全局 ref，即便页面改变也能同步)
  AIHelpSupport.registerAsyncEventListener("messageArrival", (jsonData) => {
    console.log("AIHelp message arrival", jsonData);
    unreadCount.value = jsonData.msgCount || 0;
  });

  // 3. 监听登录结果：登录成功后拉取未读数
  AIHelpSupport.registerAsyncEventListener("userLogin", (jsonData) => {
    console.log("AIHelp userLogin result", jsonData);
    if (jsonData.code === 1) {
      AIHelpSupport.fetchUnreadMessageCount();
    }
  });

  window._aiHelpRegistered = true;
  console.log("✅ AIHelp global listeners registered on window scope.");
};
</script>

<script setup>
/* global AIHelpSupport */
import {
  reactive,
  onMounted,
  watch,
  onBeforeUnmount,
  computed,
  nextTick
} from 'vue';

import {
  loginUserId,
  getUserInfo,
  getGoodsList,
  // getPaymentMethods,
  getCoupons,
  createOrder,
  syncOrderStatus,
  getUnfinishedOrder,
  continuePayment,
  getCurrentCountry,
  checkOrderStatus,
} from "@/api/payCenter";
import { trackInfo } from "@/api/tracking";
import messages from "@/lang/translation";
import { setLanguage, getLanguage } from "@/lang/index";
import { isMobileDevice } from "@/utils/currency";
import { useI18n } from 'vue-i18n';

// 获取国际化函数
const { t } = useI18n();
const baseUrl = process.env.BASE_URL;

// 响应式数据
const isPageReady = ref(false); // 页面是否加载完成
const isMobile = ref(false); // 是否移动端
const isLogin = ref(false); // 是否登录
const isApple = ref(/iPhone|iPad|iPod/i.test(navigator.userAgent)); // 是否苹果设备
const isShowInstallButton = ref(true); // 是否显示安装按钮
const isRecharged = ref(false); // 是否首充
// TODO 如果选择了较大面额的物品，相应的超过范围的优惠券，标记为不可选择的状态。
const isCouponsAvailable = ref(true); // 优惠券是否可用
const userInfo = ref(null); // 用户信息
const currentCurrency = ref("USD"); // 当前货币类型
const urlReferrer = new URLSearchParams(window.location.search).get('referrer') || localStorage.getItem('homepage_referrer');
const tipMessage = ref(""); // 提示消息
const deferredPrompt = ref(null); // 存储PWA安装事件
const offersSwiper = ref(null); // Offers 轮播实例
const currentCountry = ref("US"); // 当前国家
const languageToggleRef = ref(null); // 语言切换按钮Ref
const languageMenuRef = ref(null); // 语言菜单Ref
const isManualCouponOptOut = ref(false); // 用户是否手动取消了优惠券（如果是，则不再自动匹配）
const currentTime = ref(Date.now()); // 当前时间戳，用于倒计时组件刷新
const loginFocusPending = ref(false); // 标记是否在关闭消息后聚焦UID
let countdownTimer = null;
let lastSyncTime = 0; // 记录上次同步订单状态的时间，防止频繁调用

// 监听全局就绪状态，当 SDK 准备好后，自动触发用户信息更新
watch(isAihelpReady, (newVal) => {
  if (newVal) {
    console.log("AIHelp is ready, update user info. call updateAiHelpUser -1");
    updateAiHelpUser();
  }
});

// VIP中心链接（根据当前语言动态生成）
const vipCenterURL = computed(() => {
  return `/vip-center`;
});

// 表单数据
const formData = reactive({
  userID: "", // 用户ID
  selectedGoods: "", // 选中商品ID
  selectedPaymentMethod: "", // 选中支付方式ID
  selectedCoupon: "", // 选中优惠券ID
});

// 列表数据
const goodsList = ref([]); // 商品列表
const currentGoodsObject = ref(null); // 当前选中商品
const currentPaymentMethodList = ref([]); // 支付方式列表
const myCouponList = ref([]); // 我的优惠券
const availableCouponList = ref([]); // 可用优惠券
const currentCouponObject = ref(null); // 当前选中优惠券
const waitingPayment = ref(null); // 待支付订单

// 弹窗控制
const popup = reactive({
  isLoading: false,
  isShowMessage: false,
  isShowLanguageMenu: false,
  isShowScreenshotID: false,
  isShowBenefitsCenter: false,
  isShowCoupon: false,
  isShowOffers: false,
  isShowFAQ: false,
  isShowIncompleteOrder: false,
  isShowPaymentResults: false,
  isShowGuideAddDesktop: false,
  isPaymentSuccessful: false,
  isSyncing: false,
});

// 标签页激活状态
const rewardTabActive = ref("login");
const couponTabActive = ref("myCoupon");

// 语言菜单
const languageMenuList = ref([
  { id: "en", name: "English" },
  { id: "de", name: "Deutsch" },
  { id: "fr", name: "Français" },
  { id: "tr", name: "Türkçe" },
  { id: "ru", name: "Русский" },
  { id: "id", name: "Indonesia" },
  { id: "pt", name: "Português" },
  { id: "jp", name: "日本語" },
  { id: "ko", name: "한국어" },
  { id: "zh", name: "简体中文" },
  { id: "zh_tw", name: "繁體中文" },
]);

// 翻译文本
const translateText = reactive({
  htmlText1: messages[getLanguage() || "en"]?.htmlText1 || messages.en.htmlText1, // FAQ 富文本内容
});

// 价格格式化方法 (统一假设接口返回 price 为“分”)
const formatPrice = (priceCents, _ignoredSkuPriceType, couponOff = 0) => {
  let finalCents = Number(priceCents);
  if (couponOff > 0) {
    finalCents = finalCents * (1 - couponOff);
  }

  const valueInYuan = finalCents / 100;
  const noDecimalCurrencies = ['JPY', 'KRW', 'VND', 'IDR', 'TWD', 'CLP', 'COP'];
  const currency = currentCurrency.value || 'USD';

  if (noDecimalCurrencies.includes(currency.toUpperCase())) {
    return Math.round(valueInYuan).toString();
  } else {
    const formatted = valueInYuan.toFixed(2);
    return formatted.endsWith('.00') ? formatted.slice(0, -3) : formatted;
  }
};

// 动态加载样式表并返回 Promise
const loadStyle = (url) => {
  return new Promise((resolve) => {
    const cssId = 'pay-center-css';
    let link = document.getElementById(cssId);
    if (link) {
      resolve();
      return;
    }
    link = document.createElement('link');
    link.id = cssId;
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = () => resolve();
    link.onerror = () => resolve(); // 即使加载失败也继续，避免卡死
    document.head.appendChild(link);
  });
};

// 方法定义
// 页面初始化
const initPage = async () => {
  isMobile.value = isMobileDevice();
  popup.isLoading = true;
  try {
    // 先加载样式表
    const cssUrl = `${baseUrl}css/coc-en/pay-center.css`;
    await loadStyle(cssUrl);

    // 检查登录状态（从本地存储/接口）
    let token = localStorage.getItem("token");
    const expire = localStorage.getItem("token_expire");
    if (token && expire && Date.now() > parseInt(expire, 10)) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expire");
      token = null;
    }

    if (token) {
      isLogin.value = true;
      await fetchUserInfo().catch(err => {
        // 如果获取用户信息失败（token 无效），继续加载其他数据
        console.error("Get user info failed:", err);
      });
    }
    // 加载基础数据
    await fetchCurrentCountry(); // 这个方法现在同时处理国家检测和支付方式获取
    await fetchGoodsList();
    if (isLogin.value) {
      await fetchCoupons();
      await fetchUnfinishedOrder();
      // 检查最近的支付状态
      await checkRecentPaymentStatus();
    }
    // 无论是否已登录，最终都执行一遍 initAiHelp 以确保初始化成功并显示按钮
    initAiHelp();

    isPageReady.value = true;
  } catch (err) {
    tipMessage.value = err.message || "Initialization failed";
    popup.isShowMessage = true;
  } finally {
    popup.isLoading = false;
  }
};

// 检查最近的支付结果
const checkRecentPaymentStatus = async () => {
  const pendingOrderId = sessionStorage.getItem('pending_order_id');
  if (pendingOrderId && isLogin.value) {
    sessionStorage.removeItem('pending_order_id');
    try {
      const res = await checkOrderStatus(pendingOrderId);
      if (res.data && res.data.status) {
        if (res.data.status === 'payed') {
          popup.isPaymentSuccessful = true;
          popup.isShowPaymentResults = true;
        } else if (res.data.status === 'failed') {
          popup.isPaymentSuccessful = false;
          popup.isShowPaymentResults = true;
        } else if (res.data.status === 'pending') {
          // 如果依然是 pending，说明用户可能中途直接返回了，或者回调还没到
          // 这种情况也显示失败弹窗，让用户知道没有支付成功
          popup.isPaymentSuccessful = false;
          popup.isShowPaymentResults = true;
        }
      }
    } catch (err) {
      console.error("Check order status failed:", err);
    }
  }
};

// 接口请求：获取当前国家
const fetchCurrentCountry = async () => {
  try {
    const res = await getCurrentCountry({ referrer: urlReferrer || document.referrer });
    if (res.data && res.data.countryCode) {
      currentCountry.value = res.data.countryCode;
      currentCurrency.value = res.data.currency || "USD";
      
      // 直接从API响应中获取支付方式
      currentPaymentMethodList.value = res.data.paymentMethods || [];
      
      // 默认选中第一个支付方式
      if (currentPaymentMethodList.value.length) {
        formData.selectedPaymentMethod = currentPaymentMethodList.value[0].id;
      }
      
      // 根据国家设置默认语言
      const countryLanguageMap = {
        'CN': 'zh',
        'TW': 'zh_tw',
        'HK': 'zh_tw',
        'MO': 'zh_tw',
        'JP': 'jp',
        'KR': 'ko',
        'DE': 'de',
        'FR': 'fr',
        'TR': 'tr',
        'RU': 'ru',
        'ID': 'id',
        'BR': 'pt',
        'US': 'en',
        'GB': 'en',
        'AU': 'en',
        'CA': 'en'
      };
      
      const defaultLang = countryLanguageMap[currentCountry.value] || 'en';
      const currentLang = getLanguage();
      const savedLang = localStorage.getItem("preferred_lang");
      
      // 逻辑优化：仅当用户之前没有手动设置过语言（localStorage 为空）时，才触发基于国家的自动切换
      if (!savedLang && currentLang !== defaultLang && messages[defaultLang]) {
        setLanguage(defaultLang);
        translateText.htmlText1 = messages[defaultLang]?.htmlText1 || messages.en.htmlText1;
        console.log(`🌐 Language auto-switched based on country: ${currentLang} -> ${defaultLang}`);
      }
    }
  } catch (err) {
    console.warn('Failed to get country info, using default (US):', err.message);
    // 失败时使用默认国家
    currentCountry.value = "US";
    currentCurrency.value = "USD";
    // 失败时使用空的支付方式列表
    currentPaymentMethodList.value = [];
  }
};

// 接口请求：获取用户信息
const fetchUserInfo = async () => {
  if (!isLogin.value) return;
  
  try {
    const res = await getUserInfo({ referrer: urlReferrer || document.referrer });
    userInfo.value = res.data;
    isRecharged.value = res.data.isRecharged;
    initAiHelp(); // 由 initAiHelp 内部决定是否需要重新初始化及后续 login
  } catch (err) {
    // 处理 token 无效的情况
    if (err.message.includes('Unauthorized') || err.message.includes('Invalid token')) {
      onLogout(); // 使用现有的退出登录方法
    }
    throw err;
  }
};

// 接口请求：获取商品列表
const fetchGoodsList = async () => {
  const res = await getGoodsList();
  let list = res.data || [];
  
  // 增加返利信息：默认都显示，展示 3% 的返利
  list = list.map(item => ({
    ...item,
    isShowRebate: true,
    rebateNumber: Math.floor(item.coinNumber * 0.03) // 3% 返利，向下取整
  }));
  
  goodsList.value = list;

  // 默认选中第一个商品
  if (!formData.selectedGoods && goodsList.value.length > 0) {
    formData.selectedGoods = goodsList.value[0].id;
    currentGoodsObject.value = goodsList.value[0];
  }
};

// 接口请求：获取优惠券
const fetchCoupons = async () => {
  if (!isLogin.value) return;
  const res = await getCoupons();
  myCouponList.value = res.data.myCoupons;
  availableCouponList.value = res.data.availableCoupons;

  // 自动选择最优优惠券
  if (myCouponList.value.length > 0) {
    selectBestCoupon();
  } else {
    // 如果没有优惠券，默认选择第一个商品
    if (!formData.selectedGoods && goodsList.value.length > 0) {
      formData.selectedGoods = goodsList.value[0].id;
      currentGoodsObject.value = goodsList.value[0];
    }
  }
};

// 选择最优优惠券的函数
const selectBestCoupon = () => {
  // 如果没有可用的优惠券，直接返回
  if (!myCouponList.value.length) return;
  
  // 如果没有选中商品，尝试选择一个商品
  if (!currentGoodsObject.value) {
    // 如果有商品列表，选择第一个商品
    if (goodsList.value.length > 0) {
      formData.selectedGoods = goodsList.value[0].id;
      currentGoodsObject.value = goodsList.value[0];
    } else {
      // 如果没有商品列表，直接返回
      return;
    }
  }
  
  // 获取当前选中商品的价格
  const currentPrice = parseFloat(currentGoodsObject.value.originalPriceUsd);
  
  // 分析优惠券的折扣类型，优先选择10%的折扣，但要考虑适用范围
  let bestCoupon = null;
  
  // 先查找10%的优惠券，且适用于当前价格
  for (const coupon of myCouponList.value) {
    if (coupon.name.includes('10%')) {
      // 10%优惠券适用于价格区间的商品
      if (currentPrice >= coupon.minPrice && currentPrice <= coupon.maxPrice) {
        bestCoupon = coupon;
        break;
      }
    }
  }
  
  // 如果没有找到适用的10%优惠券，查找5%的优惠券
  if (!bestCoupon) {
    for (const coupon of myCouponList.value) {
      if (coupon.name.includes('5%')) {
        // 5%优惠券适用于价格区间的商品
        if (currentPrice >= coupon.minPrice && currentPrice <= coupon.maxPrice) {
          bestCoupon = coupon;
          break;
        }
      }
    }
  }
  
  // 如果找到最优优惠券，设置为选中状态；否则取消选中
  if (bestCoupon) {
    onSelectCoupon(bestCoupon);
  } else {
    // 取消选中优惠券
    formData.selectedCoupon = "";
    currentCouponObject.value = null;
  }
};

// 接口请求：获取未完成订单
const fetchUnfinishedOrder = async () => {
  if (!isLogin.value) return;
  if (!userInfo.value.userID) return;
  const res = await getUnfinishedOrder({user: userInfo.value.userID});
  waitingPayment.value = res.data || null;
};

// 登录
const onLogin = async () => {
  if (!formData.userID) {
    tipMessage.value = t("uidTips");
    popup.isShowMessage = true;
    return;
  }
  popup.isLoading = true;
  try {
    AIHelpSupport.resetUserInfo();

    const res = await loginUserId({ 
      userID: formData.userID,
      referrer: urlReferrer || document.referrer
    });
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("token_expire", Date.now() + 24 * 60 * 60 * 1000);
    isLogin.value = true;
    
    // 登录成功后重置之前的选择，避免新用户继承旧用户的选择
    formData.selectedGoods = "";
    formData.selectedCoupon = "";
    currentGoodsObject.value = null;
    currentCouponObject.value = null;
    isManualCouponOptOut.value = false;

    await fetchUserInfo();
    await fetchCurrentCountry(); // 这个方法现在同时处理国家检测和支付方式获取
    await fetchGoodsList();
    await fetchCoupons();
    await fetchUnfinishedOrder();
  } catch (err) {
    tipMessage.value = err.message || "Login failed";
    popup.isShowMessage = true;
  } finally {
    popup.isLoading = false;
  }
};

// 退出登录
const onLogout = () => {
  let isAiHelpShowing = AIHelpSupport.isAIHelpShowing();
  if (isAiHelpShowing) {
    AIHelpSupport.close();
  }

  localStorage.removeItem("token");
  localStorage.removeItem("token_expire");
  isLogin.value = false;
  userInfo.value = null;
  formData.userID = "";
  formData.selectedCoupon = "";
  waitingPayment.value = null;
  myCouponList.value = [];
  isManualCouponOptOut.value = false; // 重置用户手动取消优惠券的标记
  currentCouponObject.value = null; // 重置选中优惠券对象

  // 退出后默认选中第一个商品
  if (goodsList.value.length > 0) {
    formData.selectedGoods = goodsList.value[0].id;
    currentGoodsObject.value = goodsList.value[0];
  } else {
    formData.selectedGoods = "";
    currentGoodsObject.value = null;
  }

  // 退出后默认选中第一个支付方式
  if (currentPaymentMethodList.value.length > 0) {
    formData.selectedPaymentMethod = currentPaymentMethodList.value[0].id;
  } else {
    formData.selectedPaymentMethod = "";
  }
  // 退出登录时同步清除 AIHelp 登录状态
  AIHelpSupport.resetUserInfo();
};

// 选择商品
const onSelectGoods = (item) => {
  // 如果点击的是已选中的商品，则取消选中
  if (formData.selectedGoods === item.id) {
    formData.selectedGoods = "";
    currentGoodsObject.value = null;
  } else {
    formData.selectedGoods = item.id;
    currentGoodsObject.value = item;
    
    // 逻辑：如果当前选中的优惠券对新选择的商品不适用，则自动取消
    if (currentCouponObject.value && !isProductInCouponRange(item, currentCouponObject.value)) {
      formData.selectedCoupon = "";
      currentCouponObject.value = null;
    }

    // 如果当前没有选中优惠券，且用户没有手动“取消使用”，则尝试自动匹配
    if (!currentCouponObject.value && !isManualCouponOptOut.value) {
      let bestCoupon = null;
      let maxOff = -1;

      for (const coupon of myCouponList.value) {
        if (isProductInCouponRange(item, coupon)) {
          // 寻找折扣力度最大的
          if (coupon.coupon_off > maxOff) {
            maxOff = coupon.coupon_off;
            bestCoupon = coupon;
          }
        }
      }

      if (bestCoupon) {
        formData.selectedCoupon = bestCoupon.id;
        currentCouponObject.value = bestCoupon;
      }
    }
  }
};

// 选择支付方式
const onPaymentMethod = (id) => {
  formData.selectedPaymentMethod = id;
};

// 创建订单/支付
const onPurchase = async () => {
  if (!isLogin.value) {
    tipMessage.value = t("loginFirst");
    popup.isShowMessage = true;
    loginFocusPending.value = true;
    return;
  }
  if (!formData.selectedGoods) {
    tipMessage.value = t("selectGoodsTips");
    popup.isShowMessage = true;
    return;
  }
  if (!formData.selectedPaymentMethod) {
    tipMessage.value = t("selectPaymentTips");
    popup.isShowMessage = true;
    return;
  }

  popup.isLoading = true;
  try {
    // 确定用户ID
    const uid = isLogin.value && userInfo.value ? userInfo.value.userID : formData.userID;
    
    // 确定金额 (因为 originalPrice 统一为“分”，提交的 amount 也就以“分”提交给后台)
    const couponOff = currentCouponObject.value ? (currentCouponObject.value.coupon_off || 0) : 0;
    const amount = Math.round(currentGoodsObject.value.originalPrice * (1 - couponOff));

    // 构造符合 API 模式的参数 (snake_case)
    const params = {
      user_id: uid,
      goods_id: formData.selectedGoods,
      payment_method_id: formData.selectedPaymentMethod,
      prop_id: currentGoodsObject.value.propId,
      amount: amount,
      currency: currentCurrency.value,
      // TODO 安全确认，前端传参还是服务器端写死。
      return_url: window.location.href, // 支付成功后返回当前页。
      custom_params: {
        userCouponUuid: formData.selectedCoupon || ""
      }
    };

    console.log('Creating order with params:', params);

    const resOrderData = await createOrder(params);
    // 跳转到支付页面/处理支付逻辑
    console.log('Order created:', resOrderData);
    
    if (resOrderData.data && resOrderData.data.pay_url) {
      // 记录当前下单 ID，用于返回后查询状态
      sessionStorage.setItem('pending_order_id', resOrderData.data.order_id);
      // 在当前页面打开支付页面
      window.location.href = resOrderData.data.pay_url;
    } else {
      popup.isLoading = false;
    }
  } catch (err) {
    tipMessage.value = err.message || "Create order failed";
    popup.isShowMessage = true;
    popup.isLoading = false;
  }
};

// 切换语言
const onChangeLanguage = (lang) => {
  setLanguage(lang);
  updateAiHelpLang(lang);
  trackInfo('language_change', lang);
  translateText.htmlText1 = messages[lang]?.htmlText1 || messages.en.htmlText1;
  popup.isShowLanguageMenu = false;
  // 刷新页面/重新加载数据
  // initPage();
};

// 显示弹窗
const onShow = (key) => {
  popup[key] = true;
};

// 隐藏弹窗
const onHide = (key) => {
  popup[key] = false;
  
  // 如果是关闭提示消息，且处于等待登录聚焦状态
  if (key === 'isShowMessage' && loginFocusPending.value) {
    loginFocusPending.value = false;
    nextTick(() => {
      onFocusUserID();
    });
  }
};

// 聚焦用户ID输入框
const onFocusUserID = () => {
  document.getElementById("InputUID")?.focus();
};

// 格式化用户ID（示例）
const onNormalUserID = () => {
  formData.userID = formData.userID.trim();
};

// 安装APP（PWA安装逻辑/引导下载）
const onInstallApp = () => {
  // 仅将当前主页保存到桌面/主屏幕
  if (deferredPrompt.value) {
    // 触发PWA安装提示
    deferredPrompt.value.prompt();
    deferredPrompt.value = null;
  } else {
    // 不支持PWA安装的浏览器，尝试使用传统方式
    const isAppleDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    // 对于移动设备，尝试使用navigator.share API
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: window.location.href
      });
    } else if (isAppleDevice) {
      // iOS Safari不支持直接保存，用户需要手动操作
      // 这里可以什么都不做，让用户按照浏览器提示操作
    } else if (isAndroid) {
      // Android Chrome可以尝试使用Home Screen API
      if (window.chrome && window.chrome.webstore && window.chrome.webstore.install) {
        window.chrome.webstore.install();
      }
    }
    // 桌面浏览器不做任何操作，用户需要手动保存
  }      
};

// 转换并更新 AIHelp 语言
const updateAiHelpLang = (lang) => {
  if (typeof AIHelpSupport === 'undefined') return;
  
  let aiHelpLang = lang;
  if (lang === 'zh') {
    aiHelpLang = 'zh-CN';
  } else if (lang === 'zh_tw') {
    aiHelpLang = 'zh-TW';
  } else if (lang === 'jp') {
    aiHelpLang = 'ja';
  }
  
  console.log(`🌐 AIHelp language updated: ${lang} -> ${aiHelpLang}`);
  AIHelpSupport.updateSDKLanguage(aiHelpLang);
};

// 初始化 AIHelp
const initAiHelp = () => {
  if (typeof AIHelpSupport === 'undefined') {
    console.warn('AIHelp SDK not loaded');
    return;
  }

  const currentLang = getLanguage() || "en";
  let initialAiHelpLang = currentLang;
  if (currentLang === 'zh') {
    initialAiHelpLang = 'zh-CN';
  } else if (currentLang === 'zh_tw') {
    initialAiHelpLang = 'zh-TW';
  } else if (currentLang === 'jp') {
    initialAiHelpLang = 'ja';
  }

  // 根据 appBundleId 动态配置
  let domain = "gamenowtechnologylimited.aihelp.net";
  let appId = "gamenowtechnologylimited_platform_2eabf931bd6812a55b3846a58ef4bfc4"; // 默认欧美

  const bundleId = userInfo.value?.appBundleId;
  if (bundleId === 'com.fungather.coc.ios.gat' || bundleId === 'com.ratinggame.cocglb.gplay') {
    // 港澳台
    domain = "gamenowtechnologylimited.aihelp.net";
    appId = "gamenowtechnologylimited_platform_2ae8432e5cc079c326d2731148a4adba";
  }

  // 1. 注册全局注册守卫：保证 messageArrival 等回调在整个生命周期内只注册一次
  registerGlobalAiHelpListeners();

  // 2. 检测 appId 是否已经初始化：如果没变且已就绪，直接触发用户登录更新即可。
  if (lastAppId.value === appId && isAihelpReady.value) {
    console.log("AIHelp is ready, update user info. call updateAiHelpUser -2");
    updateAiHelpUser();
    return;
  }
  
  // 3. 如果需要重新初始化（AppID变了或第一次加载）
  lastAppId.value = appId;
  isAihelpReady.value = false; // 先重置就绪状态，等待其在新 AppID 下就绪

  const initConfig = {
    domain: domain,
    appId: appId,
    language: initialAiHelpLang,
  };

  AIHelpSupport.initialize(initConfig);
};

// 更新 AIHelp 用户信息
const updateAiHelpUser = () => {
  if (!isAihelpReady.value || typeof AIHelpSupport === 'undefined'){
    console.log("AIHelp not ready");
    return;
  } 

  if (isLogin.value && userInfo.value) {
    const loginConfig = {
      userId: userInfo.value.userID,
      userConfig: {
        userTags: "recharge, webpay",
        userName: userInfo.value.roleName,
        serverId: userInfo.value.serverId,
        baseLevel: userInfo.value.level,
        customData: JSON.stringify({
          level: userInfo.value.level,
        })
      }
    };
    console.log("AIHelp login (Logged in user)", loginConfig);
    AIHelpSupport.login(loginConfig);
  } else {
    // 未登录状态，传递默认空信息
    const anonymousConfig = {
      userId: "",
      userConfig: {
        userTags: "recharge, webpay",
        userName: "",
        serverId: "",
        baseLevel: 0,
        customData: ""
      }
    };
    console.log("AIHelp login (Anonymous user)", anonymousConfig);
    AIHelpSupport.login(anonymousConfig);
  }
};

// 显示 AIHelp
const onShowAiHelp = (entranceId = "CS01") => {
  // 防御性编程：如果传入的是 Event 对象而非字符串，则使用默认值
  const finalEntranceId = typeof entranceId === 'string' ? entranceId : "CS01";
  
  if (isAihelpReady.value && typeof AIHelpSupport !== 'undefined') {
    AIHelpSupport.show(finalEntranceId);
    unreadCount.value = 0; // 点击后重置小红点
  } else {
    tipMessage.value = t("loading");
    popup.isShowMessage = true;
  }
};

const onTabActive = (tabKey) => {
  if (tabKey === 'login' || tabKey === 'first' || tabKey === 'accumulated') {
    rewardTabActive.value = tabKey;
  } else if (tabKey === 'myCoupon' || tabKey === 'available') {
    couponTabActive.value = tabKey;
  }
};

// 格式化优惠券使用条件
// 判断商品是否在优惠券适用价格范围内
const isProductInCouponRange = (item, coupon) => {
  if (!coupon) return false;
  const price = item.originalPriceUsd;
  const min = coupon.minPrice || 0;
  const max = coupon.maxPrice || Infinity;
  return price >= min && price <= max;
};

const formatCouponConditions = (item) => {
  // 根据优惠券价格上限匹配商品定义里的金币值
  const maxP = parseFloat(item.maxPrice) || 0;
  const matchedGoods = goodsList.value.find(g => parseFloat(g.originalPriceUsd) === maxP);
  const amount = matchedGoods ? matchedGoods.coinNumber : (maxP * 100); // 如果没找到匹配，回退计算
  return t('couponDescription1', { amount });
};

// 格式化剩余时间倒计时
const formatTimeRemaining = (expireAt) => {
  if (!expireAt) return '';
  const diff = new Date(expireAt).getTime() - currentTime.value;
  if (diff <= 0) return 'Expired';

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  const pad = (n) => n.toString().padStart(2, '0');
  return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

// 格式化日期为 Y-m-d H:i:s
const formatDate = (dateValue) => {
  if (!dateValue) return '';
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return dateValue;

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');

  return `${y}-${m}-${d} ${h}:${min}:${s}`;
};

// 同步订单状态并刷新数据
const onSyncOrderStatus = async () => {
  if (!isLogin.value || popup.isSyncing) return;
  popup.isSyncing = true;
  try {
    const res = await syncOrderStatus();
    // 同步成功后，只有当后端返回确实有状态更新时，才重新加载列表和状态
    if (res.data && res.data.hasUpdated) {
      await fetchCoupons();
      await fetchUnfinishedOrder();
    }
  } catch (err) {
    console.error("Sync order status failed:", err);
  } finally {
    popup.isSyncing = false;
    lastSyncTime = Date.now();
  }
};

// 更新倒计时
const startCountdown = () => {
  if (countdownTimer) clearInterval(countdownTimer);
  countdownTimer = setInterval(() => {
    currentTime.value = Date.now();
    
    // 逻辑 1：前端在线，如果存在待支付订单且已过期，则触发状态同步
    if (waitingPayment.value && waitingPayment.value.orderId) {
       const expireTime = new Date(waitingPayment.value.expireDateStr).getTime();
       // 如果已过期且距离上次同步超过 15 秒，则触发同步。
       if (currentTime.value > expireTime + 2000 && (Date.now() - lastSyncTime > 15000)) {
         onSyncOrderStatus();
       }
    }
  }, 1000);
};
  
const onSelectCoupon = (item) => {
  // 如果点击已选中的优惠券，则取消选中
  if (formData.selectedCoupon === item.id) {
    formData.selectedCoupon = "";
    currentCouponObject.value = null;
    isManualCouponOptOut.value = true; // 标记为手动取消
  } else {
    formData.selectedCoupon = item.id;
    currentCouponObject.value = item;
    isManualCouponOptOut.value = false; // 重新手动选择了优惠券，恢复自动逻辑（或视为重新启用）
    // 选择最优充值档位
    selectBestGoods(item);
  }
};

const selectBestGoods = (coupon) => {
  // 如果商品列表为空，直接返回
  if (!goodsList.value.length) return;
  
  // 分析优惠券的使用范围 (从数据库字段读取)
  const minAmount = parseFloat(coupon.minPrice) || 0;
  const maxAmount = parseFloat(coupon.maxPrice) || Infinity;
  
  // 筛选出符合优惠券使用范围的商品
  const eligibleGoods = goodsList.value.filter(item => {
    const price = parseFloat(item.originalPriceUsd);
    return price >= minAmount && price <= maxAmount;
  });
  
  // 如果没有符合条件的商品，直接返回
  if (!eligibleGoods.length) return;
  
  // 选择价格最高的商品（优惠金额绝对值最大）
  const bestGoods = eligibleGoods.reduce((best, current) => {
    return parseFloat(current.originalPriceUsd) > parseFloat(best.originalPriceUsd) ? current : best;
  });
  
  // 设置为选中状态
  formData.selectedGoods = bestGoods.id;
  currentGoodsObject.value = bestGoods;
};
const onConfirmCoupon = () => {
  // 确认选择优惠券逻辑
  onHide('isShowCoupon');
};
const onContinuePayment = async () => {
  if (!waitingPayment.value || !waitingPayment.value.orderId) return;

  popup.isLoading = true;
  try {
    const res = await continuePayment(waitingPayment.value.orderId);
    if (res.data && res.data.pay_url) {
      // 记录当前下单 ID，用于返回后查询状态
      sessionStorage.setItem('pending_order_id', waitingPayment.value.orderId);
      window.location.href = res.data.pay_url;
    } else {
      popup.isLoading = false;
      throw new Error("Failed to get payment URL");
    }
  } catch (err) {
    tipMessage.value = err.message || "Failed to continue payment";
    popup.isShowMessage = true;
    popup.isLoading = false;
  }
};
const onKnownPaymentResult = () => {
  onHide('isShowPaymentResults');
};

// 监听 pageshow 事件处理历史回退
const onPageShow = (event) => {
  // event.persisted 表示页面是从 bfcache 中恢复的
  // navigation.type === 2 表示通过后退/前进按钮进入
  if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
    popup.isLoading = false;
    // 强制刷新页面以获取最新的订单状态和优惠券锁定状态
    window.location.reload();
  }
};

const closeLanguageMenu = (e) => {
  // if click inside toggle button or menu, do nothing
  if (
    popup.isShowLanguageMenu &&
    ((languageToggleRef.value && languageToggleRef.value.contains(e.target)) ||
      (languageMenuRef.value && languageMenuRef.value.contains(e.target)))
  ) {
    return;
  }
  popup.isShowLanguageMenu = false;
};

// 监听器
watch(
  () => popup.isShowOffers,
  async (newVal) => {
    if (newVal) {
      await nextTick();
      if (window.Swiper && !offersSwiper.value) {
        offersSwiper.value = new window.Swiper('.mask-swiper', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 2000,
            disableOnInteraction: false
          }
        });
      }
    } else {
      // 销毁Swiper实例
      if (offersSwiper.value) {
        offersSwiper.value.destroy();
        offersSwiper.value = null;
      }
    }
  }
);

// 生命周期钩子
onMounted(() => {
  // 监听 pageshow 事件
  window.addEventListener('pageshow', onPageShow);

  // 初始化页面
  initPage();
  trackInfo('visit');

  // 监听PWA安装事件 (initAiHelp 将由 initPage -> fetchUserInfo 驱动)
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt.value = e;
  });

  // 添加判断逻辑：当isShowInstallButton和isApple均为true时，将isShowInstallButton设置为false
  if (isShowInstallButton.value && isApple.value) {
    isShowInstallButton.value = false;
  }

  // 点击页面其他地方关闭语言列表 (使用 capture 捕获阶段)
  document.addEventListener('click', closeLanguageMenu, true);

  // 启动优惠券倒计时
  startCountdown();
});

onBeforeUnmount(() => {
  window.removeEventListener('pageshow', onPageShow);
  document.removeEventListener('click', closeLanguageMenu, true);
  if (offersSwiper.value) {
    offersSwiper.value.destroy();
    offersSwiper.value = null;
  }
  if (countdownTimer) {
    clearInterval(countdownTimer);
  }

  // 清理专属样式表，防止影响其他页面
  const cssLink = document.getElementById('pay-center-css');
  if (cssLink) {
    cssLink.remove();
  }
});
</script>

<style scoped>
/* 防止 Vue 未初始化时的闪烁 */
[v-cloak] {
  display: none !important;
}

/* AIHelp 未读消息红点 */
/* .button-aihelp-mobile,
.button-aihelp {
  position: fixed;
}
 */
.has-unread::after {
  content: '';
  position: absolute;
  top: -2px;
  right: -2px;
  width: 10px;
  height: 10px;
  background-color: #ff4440;
  border-radius: 50%;
  border: 1.5px solid #fff;
  z-index: 10;
  box-shadow: 0 0 4px rgba(0,0,0,0.3);
}

/* PC端小红点微调 */
.button-aihelp.has-unread::after {
  top: 0px;
  right: 0px;
}
</style>